import {
    GET_CITIES
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
    cities: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case GET_CITIES: {
        return {
          ...state,
          cities: action.payload,
        };
      }
      default:
        return state;
    }
};